// src/data/questions.js

export const TRAITS = ["E", "I", "S", "N", "T", "F", "P", "J"];

export const SCALE_MIN = 1;

export const SCALE_MAX = 5;

export const questions = [
  // 1 ~ 8 : 기본축 한 번씩 + 약간의 섞임
  {
    id: "Q1",
    text: "사람들이 많은 자리에 가면 대체로 에너지가 난다.",
    reverse: false,
    weights: { E: 1.0 },
  },
  {
    id: "Q2",
    text: "하루를 마무리할 때는 조용히 혼자 있는 시간이 꼭 필요하다.",
    reverse: false,
    weights: { I: 1.0 },
  },
  {
    id: "Q3",
    text: "눈앞에 보이는 사실과 디테일을 먼저 확인하는 편이다.",
    reverse: false,
    weights: { S: 1.0 },
  },
  {
    id: "Q4",
    text: "지금보다 '다음에 어떻게 될지'를 상상하는 시간이 많다.",
    reverse: false,
    weights: { N: 1.0 },
  },
  {
    id: "Q5",
    text: "결정을 내릴 때, 사람의 감정보다 기준과 원칙을 먼저 본다.",
    reverse: false,
    weights: { T: 1.0 },
  },
  {
    id: "Q6",
    text: "누군가 상처받을 것 같은 말은 논리적으로 맞아도 쉽게 하지 못한다.",
    reverse: false,
    weights: { F: 1.0 },
  },
  {
    id: "Q7",
    text: "할 일을 미리 정리해 두고 계획대로 움직일 때 마음이 편하다.",
    reverse: false,
    weights: { J: 1.0 },
  },
  {
    id: "Q8",
    text: "계획을 세우더라도 그때그때 상황에 따라 바꾸는 편이다.",
    reverse: false,
    weights: { P: 1.0 },
  },
  // 9 ~ 16 : 복합 특성 슬슬 섞기
  {
    id: "Q9",
    text: "처음 보는 사람에게도 비교적 쉽게 먼저 말을 거는 편이다.",
    reverse: false,
    weights: { E: 0.7, F: 0.3 }, // E 중심 + F(사람 온도)
  },
  {
    id: "Q10",
    text: "단체 활동보다 혼자 취미 생활을 할 때 더 편안함을 느낀다.",
    reverse: false,
    weights: { I: 1.0 },
  },
  {
    id: "Q11",
    text: "설명이나 글을 볼 때, 디테일한 부분까지 꼼꼼히 보는 편이다.",
    reverse: false,
    weights: { S: 0.8, J: 0.2 }, // S 중심 + 약간의 계획성
  },
  {
    id: "Q12",
    text: "아무 쓸모 없어도 상상하고 공상하는 시간이 즐겁다.",
    reverse: false,
    weights: { N: 1.0 },
  },
  {
    id: "Q13",
    text: "회의나 토론에서는 감정보다 논리적인 근거로 설득되어야 한다고 느낀다.",
    reverse: false,
    weights: { T: 0.9, N: 0.1 }, // T 중심 + 약간의 개념/구조
  },
  {
    id: "Q14",
    text: "누군가 힘들어 보이면, 할 일이 있어도 일단 괜찮은지 물어보게 된다.",
    reverse: false,
    weights: { F: 0.9, E: 0.1 }, // F 중심 + 약간의 외향
  },
  {
    id: "Q15",
    text: "해야 할 일을 목록으로 쭉 적어두고 체크해 나가는 걸 좋아한다.",
    reverse: false,
    weights: { J: 0.9, S: 0.1 },
  },
  {
    id: "Q16",
    text: "여행을 갈 때도 세세한 계획보다는 현지에서 그때그때 정하는 편이다.",
    reverse: false,
    weights: { P: 0.9, N: 0.1 },
  },
  // 17 ~ 24 : E/I + S/N + T/F + P/J 조합들
  {
    id: "Q17",
    text: "사람들 앞에서 발표하거나 말하는 것이 크게 부담스럽지 않다.",
    reverse: false,
    weights: { E: 1.0 },
  },
  {
    id: "Q18",
    text: "모임이 길어지면 자연스럽게 집에 가서 혼자 쉬고 싶다는 생각이 든다.",
    reverse: false,
    weights: { I: 1.0 },
  },
  {
    id: "Q19",
    text: "새로운 일을 시작할 때, 과거 비슷한 사례나 경험을 먼저 떠올린다.",
    reverse: false,
    weights: { S: 0.9, T: 0.1 },
  },
  {
    id: "Q20",
    text: "'일단 해보면 재밌겠다' 싶은 아이디어에 쉽게 끌리는 편이다.",
    reverse: false,
    weights: { N: 0.7, P: 0.3 },
  },
  {
    id: "Q21",
    text: "의견이 다를 때, 먼저 원칙이나 기준을 확인하려고 한다.",
    reverse: false,
    weights: { T: 1.0 },
  },
  {
    id: "Q22",
    text: "분위기가 싸해지는 상황을 그냥 두지 못하고, 어떻게든 풀어보려 한다.",
    reverse: false,
    weights: { F: 0.8, E: 0.2 },
  },
  {
    id: "Q23",
    text: "마감 날짜가 명확하게 정해져 있으면 오히려 안심이 된다.",
    reverse: false,
    weights: { J: 1.0 },
  },
  {
    id: "Q24",
    text: "계획대로 되지 않아도 '어찌어찌 되겠지' 하는 편이다.",
    reverse: false,
    weights: { P: 1.0 },
  },
  // 25 ~ 32 : 사람/에너지 + 상상/현실 + 계획/유연성
  {
    id: "Q25",
    text: "친한 사람을 늘려가고, 새로운 인맥을 만드는 게 즐겁다.",
    reverse: false,
    weights: { E: 0.8, N: 0.2 },
  },
  {
    id: "Q26",
    text: "하루 이상 거의 말을 하지 않고 지내도 크게 불편하지 않다.",
    reverse: false,
    weights: { I: 1.0 },
  },
  {
    id: "Q27",
    text: "눈에 보이는 결과나 성과가 없으면 허전함을 느끼는 편이다.",
    reverse: false,
    weights: { S: 0.9, J: 0.1 },
  },
  {
    id: "Q28",
    text: "미래에 이렇게 될지도 모른다는 가능성을 망상처럼 자주 떠올린다.",
    reverse: false,
    weights: { N: 1.0 },
  },
  {
    id: "Q29",
    text: "의사결정을 할 때 논리도 중요하지만, 관련된 사람들의 감정도 함께 고려하려고 한다.",
    reverse: false,
    weights: { T: 0.5, F: 0.5 }, // 논리+감정 복합 (합 1.0으로 수정)
  },
  {
    id: "Q30",
    text: "영화나 드라마를 볼 때 인물들의 감정선에 깊이 몰입하는 편이다.",
    reverse: false,
    weights: { F: 1.0 },
  },
  {
    id: "Q31",
    text: "갑작스러운 변수가 생기는 것보다, 계획대로 흘러가는 상황을 더 선호한다.",
    reverse: false,
    weights: { J: 0.9, T: 0.1 },
  },
  {
    id: "Q32",
    text: "스케줄을 꽉 채우기보다는 여유 시간도 일부러 비워 두는 편이다.",
    reverse: false,
    weights: { P: 0.9, I: 0.1 },
  },
  // 33 ~ 40 : 조금 더 복합적인 일상 상황
  {
    id: "Q33",
    text: "사람 많은 카페나 행사장에서도 오히려 에너지가 충전되는 느낌이 든다.",
    reverse: false,
    weights: { E: 1.0 },
  },
  {
    id: "Q34",
    text: "카톡이나 전화 알림이 계속 울리면 조금 지치는 편이다.",
    reverse: false,
    weights: { I: 0.8, F: 0.2 },
  },
  {
    id: "Q35",
    text: "새로운 일을 시작하기 전에 필요한 정보와 준비물을 꼼꼼히 정리해 두는 편이다.",
    reverse: false,
    weights: { S: 0.6, J: 0.4 }, // 합 1.0으로 수정
  },
  {
    id: "Q36",
    text: "여러 사례를 보다가 '앞으로 이렇게 바뀌겠구나' 하는 흐름을 잡고, 그에 맞춰 계획을 세우는 편이다.",
    reverse: false,
    weights: { N: 0.6, J: 0.4 }, // 합 1.0으로 수정
  },
  {
    id: "Q37",
    text: "다수의 의견보다도 '이게 맞는가?'라는 기준이 더 중요하다고 느낀다.",
    reverse: false,
    weights: { T: 1.0 },
  },
  {
    id: "Q38",
    text: "논리적으로 맞는 말이어도, 누군가 크게 상처받을 것 같으면 말하지 않는 편이다.",
    reverse: false,
    weights: { F: 0.9, T: 0.1 },
  },
  {
    id: "Q39",
    text: "작은 일이라도 미리 처리해 두어야 마음이 편하다.",
    reverse: false,
    weights: { J: 1.0 },
  },
  {
    id: "Q40",
    text: "해야 할 일을 마지막 순간에 몰아서 처리하는 경우가 자주 있다.",
    reverse: false,
    weights: { P: 1.0 },
  },
  // 41 ~ 50 : 에너지, 몰입, 정리 습관, 마무리 느낌
  {
    id: "Q41",
    text: "파티나 회식이 끝나도 2차, 3차까지 이어지는 게 괜찮다.",
    reverse: false,
    weights: { E: 0.7, P: 0.3 }, // 합 1.0으로 수정
  },
  {
    id: "Q42",
    text: "사람이 많은 곳보다 조용한 공간에서 훨씬 집중이 잘 된다.",
    reverse: false,
    weights: { I: 1.0 },
  },
  {
    id: "Q43",
    text: "물건을 고를 때 디자인보다 실용성과 성능을 먼저 본다.",
    reverse: false,
    weights: { S: 0.7, T: 0.3 }, // 합 1.0으로 수정
  },
  {
    id: "Q44",
    text: "현실적으로는 말이 안 돼도, 상상 속에서는 가능한 세계를 자주 떠올린다.",
    reverse: false,
    weights: { N: 1.0 },
  },
  {
    id: "Q45",
    text: "누군가 나를 비판하더라도, 내용이 맞다면 감정보다 내용부터 보려고 한다.",
    reverse: false,
    weights: { T: 0.9, I: 0.1 },
  },
  {
    id: "Q46",
    text: "갈등 상황에서는 어느 쪽이 맞는지보다, 서로 크게 다치지 않는 게 더 중요하다고 느낀다.",
    reverse: false,
    weights: { F: 0.9, N: 0.1 },
  },
  {
    id: "Q47",
    text: "다음 주 일정을 미리 캘린더나 다이어리에 정리해 두는 편이다.",
    reverse: false,
    weights: { J: 0.9, S: 0.1 },
  },
  {
    id: "Q48",
    text: "오늘 기분이나 컨디션에 따라 이미 세운 계획을 바꾸는 일도 자주 있다.",
    reverse: false,
    weights: { P: 0.9, F: 0.1 },
  },
  {
    id: "Q49",
    text: "새로운 사람과 새로운 환경에 대한 두려움보다 호기심이 더 크다.",
    reverse: false,
    weights: { E: 0.8, N: 0.2 },
  },
  {
    id: "Q50",
    text: "오랜 시간 깊게 생각할 수 있는 나만의 조용한 공간이 꼭 필요하다고 느낀다.",
    reverse: false,
    weights: { I: 1.0 },
  },
];
